export const Axis = Object.freeze({
  ALL: "all",
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
});
